export const businessInfo = {
  name: 'Meditex Healthcare Hub Limited',
  shortName: 'Meditex',
  foundedYear: 2021,
  email: 'meditexdiagnosticlaboratory@gmail.com',
  phones: ['08139203980', '07035104804', '08168348369'],
  locations: [
    {
      name: 'Ikorodu Centre',
      address: '7, Dada Borokini Street, off Lagos Road, Ikorodu, Lagos',
      mapQuery: '7 Dada Borokini Street off Lagos Road Ikorodu Lagos Nigeria'
    },
    {
      name: 'Ogijo (Sagamu) Centre',
      address: '12, MKO Abdulsalam Close, off Oladapo Street, Jigaye, Ogijo, Ogun State',
      mapQuery: '12 MKO Abdulsalam Close off Oladapo Street Jigaye Ogijo Ogun State Nigeria'
    }
  ],
  hours: [
    { days: 'Monday - Friday', time: '8am - 6pm' },
    { days: 'Saturday & Public Holidays', time: '8am - 6pm' },
    { days: 'Sunday', time: 'Closed' }
  ],
  emergencyNote: 'Outside our working hours, expect a prompt response in an emergency.'
}

export const heroSlides = [
  {
    heading: 'Diagnostic care you can trust',
    message: 'Quality is our focus, patients come first.'
  },
  {
    heading: 'Precision in every result',
    message: 'Global best-practice laboratory standards, delivered locally.'
  },
  {
    heading: 'Building a leading diagnostic brand',
    message: 'Serving Lagos and Ogun State, with our sights on Nigeria and Africa.'
  }
]

export const services = [
  {
    slug: 'medical-health-checks',
    icon: 'HeartIcon',
    name: 'Medical Health Checks',
    description: `Annual comprehensive checkups, pre-employment medical examinations, food handlers tests, pre-nuptial health screening, pre-enrolment medical tests for schools, well woman health checks, and domestic staff screening.`,
    tags: ['checkup', 'fitness', 'health screening']
  },
  {
    slug: 'blood-banking',
    icon: 'BeakerIcon',
    name: 'Blood Banking',
    description: `Blood banking and serology services (BBS), and blood donation, among other related services.`,
    tags: ['Blood', 'Bank', 'Lagos State Government Approved']
  },
  {
    slug: 'medical-lab-tests',
    icon: 'FingerPrintIcon',
    name: 'Medical Lab Tests',
    description: `Global best-practice medical laboratory services in Nigeria, providing a wide range of diagnostic services across blood, body fluids and tissue pathology, covering haematology, clinical chemistry, microbiology and more.`,
    tags: ['endocrinology', 'virology', 'parasitology']
  },
  {
    slug: 'ultrasound-scans',
    icon: 'PhotographIcon',
    name: 'Ultrasound Scans',
    description: `Obstetric (pregnancy) ultrasound, abdominal ultrasound, pelvic ultrasound, and soft tissue scans, performed by trained personnel as part of our diagnostic imaging services.`,
    tags: ['obstetric scan', 'abdominal scan', 'pelvic scan']
  },
  {
    slug: 'chemical-pathology',
    icon: 'ScaleIcon',
    name: 'Chemical Pathology',
    description: `Kidney function test (E/U/Cr), cardiac markers, liver function test, lipid profile, diabetic profile, blood minerals, blood disorders, bleeding time, blood glucose, total cholesterol, C-reactive protein, uric acid, and glycated haemoglobin.`,
    tags: ['Glucose', 'LFT', 'Lipid Profile']
  },
  {
    slug: 'microbiology',
    icon: 'SearchIcon',
    name: 'Microbiology',
    description: `Aspirate, HVS, blood, urine, wound swab, CSF, ear swab, endocervical swab, eye swab, nasal swab, pleural aspirate and pus culture & sensitivity; TB Ag and AFB; HVS routine examination; cholera Ag; Chlamydia; and faecal occult blood.`,
    tags: ['culture', 'sensitivity', 'swab']
  },
  {
    slug: 'endocrinology',
    icon: 'SparklesIcon',
    name: 'Endocrinology',
    description: `Hormonal imbalance screening, female and male hormonal profiles, thyroid function tests, growth hormone tests, ovulation tests, and HCG.`,
    tags: ['hormonal', 'profile', 'thyroid test']
  },
  {
    slug: 'virology-immunology',
    icon: 'ShieldCheckIcon',
    name: 'Virology / Immunology',
    description: `Hepatitis B sAg, A and C; Hepatitis B profile; Human Immunodeficiency Virus (HIV I & II); Hepatitis C; Hepatitis A Ag; and Venereal Disease Research Lab (VDRL) testing.`,
    tags: ['HBsAg', 'HIV', 'Hepatitis A, B and C']
  },
  {
    slug: 'parasitology',
    icon: 'ZoomInIcon',
    name: 'Parasitology',
    description: `Malaria parasitaemia, blood microfilarial worms, stool analysis, and urine analysis.`,
    tags: ['MP', 'Widal', 'Urinalysis']
  }
]

export const accreditations = [
  {
    icon: 'BeakerIcon',
    name: 'MLSCN',
    description: 'Medical Laboratory Science Council of Nigeria'
  },
  {
    icon: 'OfficeBuildingIcon',
    name: 'CAC',
    description: 'Corporate Affairs Commission'
  },
  {
    icon: 'ShieldCheckIcon',
    name: 'HEFAMAA',
    description: 'Lagos State Health Facility Monitoring and Accreditation Agency'
  }
]

export const partners = [
  'Jobi Clinic & Maternity Hospital',
  'Triumph Hospital',
  'Winners Medical Centre',
  'Ire-Anu',
  'JayKay Hospital',
  'Empire Hospital',
  'Elika Clinic',
  'B and T Hospital',
  'Owutu Clinic'
]
